module.exports = __webpack_public_path__ + "img/fzhj.d91253e5.png";